import { oneOf } from 'yafrpl/arrays';
import { replace } from 'yafrpl/strings';

import {
  LOAD_DOCUMENT_BY_ID_SUCCESS,
  LOAD_DOCUMENT_BY_UID_SUCCESS,
  LOAD_DOCUMENTS_BY_IDS_SUCCESS,
  LOAD_SINGLE_TYPE_DOC_SUCCESS,
  LOAD_DOCUMENT_SUCCESS,
  LOAD_PAGINATED_QUERY_SUCCESS,
  LOAD_DOCUMENT_BY_ID_REQUEST,
  LOAD_DOCUMENT_BY_UID_REQUEST,
  LOAD_SINGLE_TYPE_DOC_REQUEST,
  LOAD_DOCUMENT_REQUEST,
  LOAD_DOCUMENT_BY_ID_FAILURE,
  LOAD_DOCUMENT_BY_UID_FAILURE,
  LOAD_SINGLE_TYPE_DOC_FAILURE,
  LOAD_DOCUMENT_FAILURE,
} from '../actions/prismic';
import { SEARCH_SUCCESS } from '../actions/search';

export const oneOfLoadSuccessTypes = oneOf([
  LOAD_DOCUMENT_BY_ID_SUCCESS,
  LOAD_DOCUMENT_BY_UID_SUCCESS,
  LOAD_DOCUMENTS_BY_IDS_SUCCESS,
  LOAD_SINGLE_TYPE_DOC_SUCCESS,
  LOAD_DOCUMENT_SUCCESS,
  LOAD_PAGINATED_QUERY_SUCCESS,
]);

export const oneOfLoadSingleDocumentType = oneOf([
  LOAD_DOCUMENT_BY_ID_SUCCESS,
  LOAD_DOCUMENT_BY_UID_SUCCESS,
  LOAD_SINGLE_TYPE_DOC_SUCCESS,
  LOAD_DOCUMENT_SUCCESS,
  LOAD_DOCUMENT_BY_ID_REQUEST,
  LOAD_DOCUMENT_BY_UID_REQUEST,
  LOAD_SINGLE_TYPE_DOC_REQUEST,
  LOAD_DOCUMENT_REQUEST,
  LOAD_DOCUMENT_BY_ID_FAILURE,
  LOAD_DOCUMENT_BY_UID_FAILURE,
  LOAD_SINGLE_TYPE_DOC_FAILURE,
  LOAD_DOCUMENT_FAILURE,
]);

export const oneOfLoadPaginateSuccessType = oneOf([SEARCH_SUCCESS]);

export const convertTypeToFailure = replace(/_SUCCESS$/, '_FAILURE');
